import CloseRounded from '@mui/icons-material/CloseRounded';
import { Box, Typography } from '@mui/material';

interface NoSearchResultsIconProps {
  width: number;
  height: number;
}

export function EmptySearchIcon({ width, height }: NoSearchResultsIconProps) {
  return (
    <Box sx={{ position: 'relative', color: 'primary.dark', width, height }}>
      <CloseRounded
        sx={{
          width: '100%',
          height: '100%',
        }}
      />
      <Typography
        sx={{
          position: 'absolute',
          fontSize: `${Math.round(height * 0.63)}px`,
          right: '-6px',
          top: 0,
        }}
      >
        🔍
      </Typography>
    </Box>
  );
}
